import { mainApiSplitApi } from 'redux/store/mainSplitApi'

export const featureToggleApi = mainApiSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getFlag: builder.query<boolean, string>({
      query: (flagName) => {
        return {
          url: `/feature-toggles/${flagName}`,
          method: 'GET'
        }
      }
    }),
    getIntFlag: builder.query<{ enabled: boolean, number: number }, string>({
      query: (flag) => {
        return {
          url: `/feature-toggles/int/${flag}`,
          method: 'GET'
        }
      }
    })
  }),
  overrideExisting: false
})

export const { useGetFlagQuery, useGetIntFlagQuery } = featureToggleApi
